import React from 'react'

export const Management = () => {
  return (
    <div>Management</div>
  )
}
